export default __webpack_public_path__ + "cdb6235047590b85694956f2b203fc38.png";